import React from "react";
import ChartBase from "./ChartBase";

const BarCharts = ({
  series = [],
  categories = [],
  options = {},
  height = "100%",
  width = "100%",
}) => {
  const baseOptions = {
    chart: {},
    dataLabels: { enabled: false },
    xaxis: { categories },
    bar: { gap: 6, radius: 2 },
  };

  const mergedOptions = {
    ...baseOptions,
    ...options,
    xaxis: { ...baseOptions.xaxis, ...(options.xaxis || {}), categories },
    bar: { ...baseOptions.bar, ...(options.bar || {}) },
  };

  return (
    <ChartBase
      type="bar"
      series={series}
      categories={categories}
      options={mergedOptions}
      height={height}
      width={width}
    />
  );
};

export default BarCharts;
